// One delegated handler also covers recommendations replaced by cart sections.
document.addEventListener('click', async (event) => {
  const button = event.target.closest('.variant-upsell-button-drawer');
  if (!button || button.disabled) return;
  event.preventDefault();

  const drawer = button.closest('cart-drawer');
  if (!drawer) return;
  button.classList.add('loading');
  button.disabled = true;

  try {
    const response = await fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: button.dataset.variantId,
        quantity: 1,
        sections: drawer.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      }),
    });
    const cartData = await response.json();
    if (!response.ok || cartData.status) {
      throw new Error(cartData.description || window.cartStrings.error);
    }
    drawer.setActiveElement(document.querySelector('#cart-icon-bubble'));
    drawer.renderContents(cartData);
    await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'variant-upsell', cartData });
  } catch (error) {
    console.error('Error:', error);
  } finally {
    button.classList.remove('loading');
    button.disabled = false;
  }
});
